export const trimInsertedPrompt = (prompt: string) => prompt.trim();

/**
 * Collects file objects from a paste event's clipboard data. Screenshots
 * (Win+Shift+S on Windows) arrive as clipboard files; some browsers only
 * expose them through data items rather than the `files` list, so both are
 * checked before falling back to an empty result.
 */
export const filesFromClipboardData = (data: DataTransfer | null): File[] => {
  if (!data) {
    return [];
  }
  const files = Array.from(data.files ?? []);
  if (files.length > 0) {
    return files;
  }
  return Array.from(data.items ?? [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null);
};
